import { Component, OnInit, computed, inject, signal } from '@angular/core';
import {SimpleXploreItemDTO} from "../../../shared/object/xplorer-be-parsed-classes";
import {UserService} from "../../../services/user/user.service";
import {MetaDataService} from "../../../services/meta/meta-data.service";
import { TranslateModule } from '@ngx-translate/core';
import { PreviewItemCardComponent } from '../../components/preview-item-card/preview-item-card.component';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { PlaceholderCardComponent } from '../../components/placeholder-card/placeholder-card.component';


@Component({
    selector: 'xplorer-bowser-favorites-page',
    templateUrl: './favorites-page.component.html',
    styleUrls: ['./favorites-page.component.css'],
    imports: [PlaceholderCardComponent, InfiniteScrollDirective, PreviewItemCardComponent, TranslateModule]
})
export class FavoritesPageComponent implements OnInit {

  isLoading = signal<boolean>(true);
  favorites = signal<SimpleXploreItemDTO[]>([]);
  skeletons = signal<number[]>(Array(12).fill(0));
  hasFavorites = computed(() => this.favorites().length > 0);

  private userService: UserService = inject(UserService);
  private metaDataService: MetaDataService = inject(MetaDataService);


  ngOnInit(): void {
    this.retrieveFavorites();
    this.metaDataService.setDefaultMetaData();
  }

  retrieveFavorites(): void {
    this.userService.getFavorites()
      .subscribe(favorites => {
        if(!favorites || favorites?.length === 0) {
          this.isLoading.set(false);
          return;
        }

        const totalFavorites = favorites.length;
        this.skeletons.set(Array(totalFavorites).fill(0));

        this.favorites.set(favorites.map(favorite => favorite.xploreItem));

        this.isLoading.set(false);
      }
    );
  }
}
